import React from "react";

import Button from "@mui/material/Button/Button";
import { ComponentSpacing } from "../../../../../shared/components/Spacing/Spacing";
import styles from "./styles.module.css";
import { getOS, getStoreLink } from "./utils";
import localStorageService from "../../../../../shared/services/localStorage/localStorage";
import { SEEN_DISMISSED_DOWNLOAD_APP_CTA_AT } from "../../../../../shared/services/localStorage/keys";

export function DownloadAppBottomSheet(): JSX.Element | null {
  const [visible, setVisible] = React.useState(false);

  const resolveVisibility = React.useCallback(() => {
    const seenAt = localStorageService.retrieve<Date>({
      key: SEEN_DISMISSED_DOWNLOAD_APP_CTA_AT,
    });

    const timeAgo = seenAt && new Date().getTime() - new Date(seenAt).getTime();
    const THIRTY_DAYS = 60000 * 60 * 24 * 30;

    setVisible(timeAgo === undefined || timeAgo > THIRTY_DAYS);
  }, []);

  const dismiss = React.useCallback(() => {
    localStorageService.save({
      key: SEEN_DISMISSED_DOWNLOAD_APP_CTA_AT,
      data: new Date(),
    });

    resolveVisibility();
  }, [resolveVisibility]);

  const onDownloadPress = React.useCallback(() => {
    dismiss();
    window.open(getStoreLink(), "_blank");
  }, [dismiss]);

  React.useEffect(resolveVisibility, [resolveVisibility]);

  if (!visible) return null;

  if (getOS() === "iOS") return null;

  return (
    <div className={styles.sheet}>
      <div>
        <strong>
          <span className={styles["primary-text"]}>figurinhas</span>
          <span className={styles["brand-color-2"]}>.web</span>
          <span className={styles["brand-color-2"]}>.app</span> é melhor no app
        </strong>
      </div>

      <ComponentSpacing />

      <div>
        Baixe o app para fazer o controle e trocas das suas figurinhas com mais
        facilidade e rapidez.
      </div>

      <ComponentSpacing />

      <div className={styles.buttons}>
        <Button fullWidth onClick={dismiss} size="medium">
          Agora não
        </Button>

        <ComponentSpacing />

        <Button
          fullWidth
          onClick={onDownloadPress}
          size="medium"
          variant="contained"
        >
          Baixar
        </Button>
      </div>
    </div>
  );
}
